<template>
  <div class="pageview">
    <div class="contentmsg">
      <van-sticky>
        <van-tabs
          color="#f63e3b"
          title-active-color="#f63e3b"
          @click="onClickOnlyOne"
        >
          <van-tab name="全部" title="全部"> </van-tab>
          <van-tab
            v-for="item in CateList"
            :key="item.AKId"
            :name="item.AKId"
            :title="item.Name"
          >
          </van-tab>
        </van-tabs>
      </van-sticky>

      <div class="information">
        <div
          class="center"
          style="padding: 17px 16px"
          v-for="(item, index) in List"
          :key="index + 'aa'"
        >
          <!-- v-show="item.AKId != 9" -->
          <div class="nian" v-if="index == 0">
            {{ item.IssTime.split("-")[0] }}年
          </div>
          <div
            class="nian"
            v-if="
              index > 0 &&
              List[index - 1].IssTime.split('-')[0] !=
                item.IssTime.split('-')[0]
            "
          >
            {{ item.IssTime.split("-")[0] }}年
          </div>
          <div
            v-if="index == 0"
            style="
              position: relative;
              top: -8px;
              width: 50px;
              height: 5px;
              background: linear-gradient(to right, #d44f43, #fff);
            "
          ></div>
          <div
            v-if="
              index > 0 &&
              List[index - 1].IssTime.split('-')[0] !=
                item.IssTime.split('-')[0]
            "
            style="
              position: relative;
              top: -8px;
              width: 50px;
              height: 5px;
              background: linear-gradient(to right, #d44f43, #fff);
            "
          ></div>

          <div>
            <div
              style="
                display: flex;
                margin-bottom: 10px;
                margin-top: 14px;
                align-items: center;
              "
            >
              <span class="yue">{{
                item.IssTime.split(" ")[0].split("-")[1] +
                "/" +
                item.IssTime.split(" ")[0].split("-")[2]
              }}</span>
              <span class="yuan"></span>
              <div class="title">{{ item.Title }}</div>
            </div>

            <div
              style="display: flex"
              @click="gotoUrl('/fivestar/wuXingXq/' + item.AId + '-1')"
            >
              <div class="line"></div>
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: baseline;
                  width: 80%;
                "
              >
                <!-- <div class="content">
                  <span v-html="item.Content"></span>
                </div> -->
                <div class="img" ref="getHeight">
                  <img
                    v-if="item.AImg != null && item.AImg != ''"
                    :src="item.AImg"
                    alt=""
                    style="min-height: 70px"
                  />
                  <img
                    v-else
                    src="http://alycommunity.anluoyun.cn/sx-jgz/2023/6/d230d06c-3c3.png"
                    alt=""
                    style="min-height: 70px"
                  />
                </div>
                <div class="recman">发布人：{{ item.AuditMan }}</div>
              </div>
            </div>
          </div>
        </div>
        <van-empty description="暂无信息" v-if="!List.length" />
      </div>
    </div>
  </div>
</template>

<script>
import { WxGetAKindList, WxGetRecruitActivityPage } from "@/api/RealInfo";
import wx from "weixin-js-sdk";
import { setOpenId, getOpenId } from "@/utils/auth";
export default {
  data() {
    return {
      List: [],
      CateList: [],
    };
  },
  created() {
    // 获取并保存openid
    if (this.$route.query["openid"]) {
      // this.$store.dispatch('user/setopenid', { openid: this.$route.query['openid'] })
      setOpenId(this.$route.query["openid"]);
    }
    this.getInfoKindInfoPage();
    this.getPartyInfoList("");
  },
  methods: {
    // 获取资讯分类
    async getInfoKindInfoPage() {
      const res = await WxGetAKindList({ Cate: 2 });
      console.log(res, "res");
      res.data.data.forEach((e) => {
        if (e.Name != "三会一课") {
          this.CateList.push({
            AKId: e.AKId,
            Name: e.Name,
          });
          // this.getPartyInfoList(e.AKId)
        }
      });
      console.log(this.CateList, "this.CateList");
    },
    //跳转到公共页面
    gotoUrl(path) {
      if (window.__wxjs_environment === "miniprogram") {
        window.wx.miniProgram.navigateTo({
          url: "../public/goto?path=" + path,
        });
      } else {
        this.$router.push(path);
      }
    },
    onClickOnlyOne(name, title) {
      console.log(name);
      if (name == "全部") {
        this.getPartyInfoList("");
      } else {
        this.getPartyInfoList(name);
      }
    },
    // 通知消息
    getPartyInfoList(val) {
      WxGetRecruitActivityPage({
        page: 1,
        limit: 10,
        AKCate: 2,
        cate: 2,
        status: 3,
        aKId: val,
      }).then((res) => {
        this.List = res.data.data;
        for (var i = 0; i < this.List.length; i++) {
          var item = this.List[i].IssTime;
          item = this.dataFormat(item);
          this.List[i].IssTime = item;
        }
      });
    },
    // 时间格式化
    dataFormat(value) {
      var year = value.substr(0, 4);
      var month = value.substr(5, 2);
      var day = value.substr(8, 2);
      var hour = value.substr(11, 2);
      var min = value.substr(14, 2);
      var second = value.substr(17, 2);
      return (
        year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + second
      );
    },
  },
};
</script>
<style scoped>
.ContentB {
  display: inline-block;
  width: 50% !important;
  margin-right: 14%;
  color: #666666 !important;
  margin-left: 5% !important;
}
.djlink {
  margin-top: 1.5vh;
  border-radius: 10px;
  overflow: hidden;
  display: block;
  font-size: 0;
}
.contentA {
  width: 100%;
  overflow: hidden;
  line-height: 30px;
  padding: 2vh 1.5vh 0vh 1.5vh;
  box-sizing: border-box;
}
.contentA img {
  float: left;
  width: 16px;
  height: 16px;
  margin-right: 10px;
  margin-top: 7px;
}
.contentA span {
  float: left;
  font-size: 18px;
  color: #333333;
  font-weight: 700;
  line-height: 30px;
}
.contentA .newsmore {
  float: right;
  color: #777;
  font-size: 14px;
  line-height: 30px;
}
.contentA .blue {
  color: #477fff;
}
.pageview {
  background: #fff;
  min-height: 100%;
  /* padding: 1vh; */
  box-sizing: border-box;
}
.homebanner img {
  width: 100%;
  height: 27vh;
  vertical-align: top;
}
.wktype {
  padding: 0;
  margin-top: 1.5vh;
}
.wktype .iconimg {
  width: 65%;
}
.wktype .wktext {
  margin-top: 8px;
  font-size: 12px;
}
.contentmsg {
  background: #fff;
  /* margin-top: 1.5vh; */
  border-radius: 8px;
}
.grouptitle {
  border-left: 4px solid #1989fa;
  text-indent: 15px;
  font-weight: normal;
  font-size: 15px;
  margin: 5px 10px 0px;
}
/deep/.wktype .van-grid-item__content {
  padding: 20px 3px;
}
.moreCount {
  color: #999999 !important;
  float: right !important;
  margin-right: 7px !important;
  font-size: 14px !important;
  font-style: initial !important;
}
.moreImg {
  float: right !important;
  width: 8px !important;
  height: 12px !important;
  margin-top: 9px !important;
}

.nian {
  position: relative;
  z-index: 1;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #231815;
}

.yuan {
  width: 7px;
  height: 7px;
  background: rgb(252, 72, 57);
  display: inline-block;
  border-radius: 50%;
  vertical-align: middle;
  margin: 7px 0;
}
.yue {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #231815;
  margin-right: 8px;
}

.line {
  width: 1px;
  /* height: 118px; */
  background: #e8e8e8;
  margin-left: 52px;
  margin-right: 22px;
}

.title {
  margin-left: 21px;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #231815;
  /* overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis; */
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  flex: 1;
}

.content {
  /* height: 63px; */
  font-size: 14px;
  font-family: PingFang SC;
  color: #231815;
  font-weight: normal;
  margin-top: 6px;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  width: 100%;
}

.img img {
  border-radius: 11px;
  height: 74px;
  width: 74px;
  margin-top: 12px;
}

.recman {
  margin-top: 10px;
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
}

/deep/ .van-tab {
  font-size: 15px;
  font-weight: 400;
  color: #666666;
  /* color: #000000; */
  /* font-family: PingFangSC; */
}

/deep/ .van-tab--active {
  font-weight: bold;
  font-size: 15px;
  color: #fc4839;
}

/deep/ .content p {
  margin: 0;
  margin-top: 6px;
}
</style>
